import ExcelJS from 'exceljs';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress } from '@mui/material';
import { useEnumApi } from 'contexts/EnumApiContext';
import { getEquipmentsByQuery } from './axios/equipmentAxios';

const EquipmentExcelDownload = ({excelParam}) => {
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t, i18n } = useTranslation();

    const title = t('message.common.registration.equipment');
    const excelHeader = [
        "No."
        , t('message.common.subtitle.opStatus')
        , t('message.common.subtitle.recent.inspection')
        , getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title
        , t('message.common.subtitle.zone')
        , getEnumValueByEnumNameAndCode("CompanyType", 'MNT')?.[0]?.title
        , t('message.common.subtitle.equipment.level1')
        , t('message.common.subtitle.equipment.level2')
        , t('message.common.subtitle.equipment.level3')
        , t('message.common.subtitle.equipment.name') 
        , t('message.common.subtitle.equipment.number')
        // , t('message.common.subtitle.modelName')
        , t('message.common.subtitle.position')
        , getEnumValueByEnumNameAndCode("CompanyType", 'MFR')?.[0]?.title
        , t('message.common.subtitle.iot.installation')
        // , t('message.common.subtitle.defect')
    ];
    if (platformServer === 'NANTONG') {
      excelHeader.splice(3, 3)

      // 호선, 역사 추가
      excelHeader.splice(3, 0, t('message.common.subtitle.subwayline')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      excelHeader.splice(4, 0, t('message.common.subtitle.station')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    }

    const filename = title+"_"+Date.now()+".xlsx";
    const [excelDatas, setExcelDatas] = useState([]);

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        horizontalCentered: true,
      },
    });
    ws.pageSetup.margins = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };
  
    let excelData = [];
    excelData.push(
      {
        data: [title],
      },
      {
        data: [],
      }
    );

    // headerTitle
    excelData.push({data : excelHeader});

    // excelData
    excelDatas.forEach((item, index) => {
        excelData.push({data : item});
    });

    excelData.forEach((item, index) => {
      ws.getRow(index + 1).values = [...item.data];
    });
  
    let dataStartIdx = 4;
    
    // 셀 병합
    let charCode;
    if ((excelHeader.length-1) < 26) {
        charCode = String.fromCharCode(65+(excelHeader.length-1));
    } else {
        let firstStr = String.fromCharCode(65+parseInt((excelHeader.length-1)/26)-1);
        let secondStr = String.fromCharCode(65+((excelHeader.length-1)%26));
        charCode = firstStr+secondStr;
    }
    ws.mergeCells('A1:'+charCode+'1');

    // 폰트 사이즈, 굵기, 색상 변경
    ws.getCell('A1').font = { size: 18, bold: true, color: { argb: '000000' } };
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').font = { bold: true };
    });

    // 정렬
    ws.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').alignment = { horizontal: 'center', vertical: 'middle' };
    });
    
    excelDatas.forEach((item, index) => {
        excelHeader.forEach((item2, index2) => {
            let charCode;
            if (index2 < 26) {
                charCode = String.fromCharCode(65+index2);
            } else {
                let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                let secondStr = String.fromCharCode(65+(index2%26));
                charCode = firstStr+secondStr;
            }
            ws.getCell(charCode+(index+dataStartIdx)).alignment = { horizontal: 'center', vertical: 'middle' };
        });
    });

    // 색 칠하기
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e0e0e0' },
        };
    });
    
    
    // 테두리
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').border = {
            top: { style: 'medium', color: { argb: '000000' } },
        };
    });
    
    excelDatas.forEach((item, index) => {
        
        excelHeader && excelHeader.forEach((item2, index2) => {
                let charCode;
                if (index2 < 26) {
                    charCode = String.fromCharCode(65+index2);
                } else {
                    let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                    let secondStr = String.fromCharCode(65+(index2%26));
                    charCode = firstStr+secondStr;
                }
                ws.getCell(charCode+(index+dataStartIdx)).border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                };
                if (index === (excelDatas.length-1)) {
                    let charCode;
                    if (index2 < 26) {
                        charCode = String.fromCharCode(65+index2);
                    } else {
                        let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                        let secondStr = String.fromCharCode(65+(index2%26));
                        charCode = firstStr+secondStr;
                    }
                    ws.getCell(charCode+(index+dataStartIdx)).border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                    };
                }
            });
    });

    // 가로 길이
    const col = [];
    for (let i = 0; i < excelHeader.length; i++) {
        col.push({
            key: 'data',
            width: 15,
        });
    }
    ws.columns = col;
  
    // 세로 길이
    for (let i = 1; i <= excelData.length; i++) {
      let row = ws.getRow(i);
      row.height = 22;
    }
  
    // 줄 바꿈
    const [finish, setFinish] = useState('standby');

    useEffect(() => {
        if (finish === 'end') {
            setFinish('standby')
            wb.xlsx.writeBuffer().then((b) => {
                let a = new Blob([b]);
                let url = window.URL.createObjectURL(a);
        
                let elem = document.createElement('a');
                elem.href = url;
                elem.download = filename;
                elem.click();
                elem.remove();
            });
        }
    }, [finish])

    const download = () => {
        setFinish('progress')
        Promise.all([
            getEquipmentsByQuery(excelParam).then((data)=>{
                if (data != null) {
                //  console.log(data);
                  if(data._embedded) {
                    let list = data._embedded.equipments;
                    let excelDatas = [];
                    let excelData = [];
                    list && list.forEach(function (column, a) {
                      excelData = [
                        (data.page.totalElements-a),
                        ((getEnumValueByEnumNameAndCode("EquipmentOpStatus", column?.opStatus)?.[0]?.title) || ''),
                        ((column?.latestCommYmd) || ''),
                        ((column?.managementCompany?.info?.name) || ''),
                        ((column?.zone?.name) || ''),
                        ((column?.maintenanceCompany?.info?.name) || ''),
                        ((column?.equipmentCtgr?.parent?.parent?.name) || ''),
                        ((column?.equipmentCtgr?.parent?.name) || ''),
                        ((column?.equipmentCtgr?.name) || ''),
                        ((column?.name) || ''),
                        ((column?.equipmentNo) || ''),
                        // ((column?.modelName) || ''),
                        ((column?.location) || ''),
                        // ((column?.madeYmd) || ''),
                        // ((column?.instlYmd) || ''),
                        ((column?.manufacturingCompany?.info?.name) || ''),
                        (column?.iotInstlYn ? 'O':'X')
                      ];
                      if (platformServer === 'NANTONG') {
                        excelData.splice(3, 3)

                        // 호선, 역사 추가
                        excelData.splice(3, 0, ((column?.zone?.category?.name?.[i18n.language.substring(0, 2)]) || '')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
                        excelData.splice(4, 0, ((column?.zone?.name) || '')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
                      }
                      excelDatas.push(excelData);
                    });
                    setExcelDatas(excelDatas);
                  } else {
                    setExcelDatas([]);
                  }
                } else {
                  setExcelDatas([]);
                }
                setFinish('end')
            })
        ]).then(() => {
        });
    }

    return (
        (finish === 'standby' || finish === 'end') ?
        <Button variant="contained" color="success" onClick={download} style={{margin:"5px", top:"-5px"}}>
          {t('message.common.btn.excel.download')}
        </Button>
        :
        <div className='no-print-page' style={{color:"#000"}}>
            <Box sx={{ display: 'flex', color:"#000" }}>
                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
            </Box>
        </div>
    )
};

export default EquipmentExcelDownload;